import React from 'react'
import ReactDOM from 'react-dom/client' // ⬅️ switch to react-dom/client
import App from './App'
import reportWebVitals from './reportWebVitals'
import '@teschglobal/tg-fhir-react-components/style.css'
import './index.scss'

import { HelmetProvider } from 'react-helmet-async'

const container = document.getElementById('root')!
const root = ReactDOM.createRoot(container) // ⬅️ create the root

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
)

reportWebVitals()
